export default __webpack_public_path__ + "static/media/PrivateEvents1.f417f143.jpg";